import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from '../css/Galeria.module.css';

const CLOUD_NAME = "dvxhzufjh";
const TAG_GALERIA = "iglesia"; 

const Galeria = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [folders, setFolders] = useState({});
    const [selectedFolder, setSelectedFolder] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    // 1. ESCUCHA DE URL (Sincronización Total)
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const albumName = params.get('album');
        
        // Si la URL ya no tiene el ?album=, cerramos la carpeta
        if (!albumName) {
            setSelectedFolder(null);
        } else {
            setSelectedFolder(albumName);
        }
    }, [location.search]); // Se ejecuta cada vez que la URL cambia

    // 2. CARGA DE DATOS
    useEffect(() => {
        fetch(`https://res.cloudinary.com/${CLOUD_NAME}/image/list/${TAG_GALERIA}.json?v=${new Date().getTime()}`)
            .then(res => res.json())
            .then(data => {
                const grouped = data.resources.reduce((acc, img) => {
                    const pathParts = (img.asset_folder || "General").split('/');
                    const folder = pathParts[pathParts.length - 1];
                    if (!acc[folder]) acc[folder] = [];
                    acc[folder].push(img);
                    return acc;
                }, {});
                setFolders(grouped);
                setIsLoading(false);
            })
            .catch(err => {
                console.error("Error al cargar:", err);
                setIsLoading(false);
            });
    }, []);

    // 3. NAVEGACIÓN HACIA EL ÁLBUM
    const handleOpenFolder = (folderName) => {
        // 1. Cambiamos el estado local (para que se vean las fotos)
        setSelectedFolder(folderName);
        
        // 2. CAMBIAMOS LA URL (Para que el Navbar despierte y muestre "Atrás")
        // Fíjate bien en las comillas invertidas ` y el signo ?
        navigate(`/galeria?album=${folderName}`);
        
        // 3. Subimos al principio para que no se vea a medias
        window.scrollTo(0, 0);
    };

    const downloadImage = (url, filename) => {
        const link = document.createElement("a");
        link.href = url.replace("/upload/", "/upload/fl_attachment/");
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className={styles.container}>
            <main className={styles.main}>
                <header className={styles.header}>
                    <h1 className={styles.title}>
                        {selectedFolder ? selectedFolder.replace(/_/g, ' ') : "Nuestros Momentos"}
                    </h1>
                    <div className={styles.divider}></div>
                </header>

                {isLoading ? (
                    <div className={styles.loaderWrapper}>
                        <div className={styles.spinner}></div>
                        <p>Cargando recuerdos...</p>
                    </div>
                ) : !selectedFolder ? (
                    /* --- VISTA DE ÁLBUMES (GRILLA) --- */
                    <div className={styles.albumGrid}>
                        {Object.keys(folders).map((folderName) => (
                            <div 
                                key={folderName} 
                                className={styles.albumCard} 
                                onClick={() => handleOpenFolder(folderName)}
                            >
                                <div className={styles.imageWrapper}>
                                    <img 
                                        src={`https://res.cloudinary.com/${CLOUD_NAME}/image/upload/f_auto,q_auto,w_600,c_fill,ar_4:5/v${folders[folderName][0].version}/${folders[folderName][0].public_id}.${folders[folderName][0].format}`} 
                                        alt={folderName} 
                                    />
                                    <div className={styles.albumOverlay}>
                                        <span className={styles.photoCount}>
                                            <i className="fas fa-camera"></i> {folders[folderName].length}
                                        </span>
                                    </div>
                                </div>
                                <div className={styles.albumInfo}>
                                    <h3>{folderName.replace(/_/g, ' ')}</h3>
                                    <p>Ver álbum <i className="fas fa-chevron-right"></i></p>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    /* --- VISTA DE FOTOS (CASCADA) --- */
                    <div className={styles.photoGrid}>
                        {folders[selectedFolder]?.map((img) => {
                            const fullUrl = `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/v${img.version}/${img.public_id}.${img.format}`;
                            return (
                                <div key={img.public_id} className={styles.photoItem}>
                                    <img 
                                        src={`https://res.cloudinary.com/${CLOUD_NAME}/image/upload/f_auto,q_auto,w_800/v${img.version}/${img.public_id}.${img.format}`} 
                                        alt="Recuerdo IUMP" 
                                    />
                                    <div className={styles.photoActions}>
                                        <a href={fullUrl} target="_blank" rel="noopener noreferrer">
                                            <i className="fas fa-expand"></i>
                                        </a>
                                        <button onClick={() => downloadImage(fullUrl, img.public_id)}>
                                            <i className="fas fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </main>
        </div>
    );
};

export default Galeria;